import { LocalDate } from '../../../utilities/local-date';
import { timeInMinutes } from './time-in-minutes';

export function isInvalidPeriod(startDate: string, startTime: string, endDate: string, endTime: string): boolean {
  const startDateObj = LocalDate.fromString(startDate);
  const endDateObj = LocalDate.fromString(endDate);
  return (
    startDateObj.isAfter(endDateObj) ||
    (startDateObj.isSame(endDateObj) &&
      startTime !== 'NONE' &&
      endTime !== 'NONE' &&
      timeInMinutes(endTime) < timeInMinutes(startTime) + 5)
  );
}
